export const firebase = require('firebase');
require('firebase/auth');
require('firebase/database');

const firebaseui = require('firebaseui');

// Initialize Firebase
const config = {
    apiKey: "AIzaSyAH1RSdS7i_7pcdCqpGh1sojyDg-J1KC90",
    authDomain: "wordy-goals.firebaseapp.com",
    databaseURL: "https://wordy-goals.firebaseio.com",
    projectId: "wordy-goals",
    storageBucket: "wordy-goals.appspot.com",
    messagingSenderId: "106040424866"
};

firebase.initializeApp(config);

const auth = firebase.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);

export const authUI = new firebaseui.auth.AuthUI(auth);

export const database = firebase.database();

export function dbUserGoals(userId) {
    return database.ref(`goals/${userId}`);
};



// WEBPACK FOOTER //
// ./src/utils/firebase.js